module.exports = __webpack_public_path__ + "img/新增数据.cde85005.svg";